import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { get } from 'lodash';
import { required } from 'vee-validate/dist/rules';

@Component
export default class AbstractField extends Vue {
  @Prop(String) readonly id: string;

  @Prop({
    type: Boolean,
    default: null,
  })
  readonly state: boolean;

  @Prop({
    type: [Object, Array],
    default() {
      return {};
    },
  })
  readonly wrapperAttributes: object | string[];

  @Prop({
    type: Boolean,
    default: true,
  })
  readonly showLabel: boolean;

  @Prop(String) readonly label: string;

  @Prop([String, Object, Array]) readonly labelClass: string | object | string[];

  @Prop([Object, Array]) readonly labelAttributes: object | string[];

  @Prop(String) readonly name: string;

  @Prop([String, Array, Object]) readonly fieldClass: string | string[] | object;

  @Prop([Object, Array]) readonly fieldAttributes: object | string[];

  @Prop(Boolean) readonly veeValidation: boolean;

  @Prop({
    type: Boolean,
    default: true,
  })
  readonly showError: boolean;

  @Prop([String, Object, Array]) readonly errorClass: string | object | string[];

  @Prop([Object, Array]) readonly errorAttributes: object | string[];

  @Prop(String) readonly error: string;

  @Prop([String, Object, Array]) readonly rules: string | null | string[];

  @Prop({
    type: Boolean,
    default: true,
  })
  readonly showHelp: boolean; // Deprecated help is shown if the translation exists

  @Prop([String, Object, Array]) readonly helpClass: string | object | string[];
  @Prop([String]) readonly helpMode: 'tooltip' | 'displayed_below' | 'hidden';

  @Prop([Object, Array]) readonly helpAttributes: object | string[];

  @Prop(String) readonly help: string;

  @Prop({
    type: Boolean,
    default: true,
  })
  readonly showFeedback: boolean;

  @Prop([String, Object, Array]) readonly feedbackClass: string | object | string[];

  @Prop([Object, Array]) readonly feedbackAttributes: object | string[];

  @Prop(String) readonly feedback: string;

  @Prop(String) readonly icon: string;

  @Prop(String) readonly prependIcon: string;
  @Prop(String) readonly prependText: string;
  @Prop(String) readonly appendIcon: string;
  @Prop(String) readonly appendText: string;

  @Prop(Boolean) readonly disabled: boolean;
  @Prop(Boolean) readonly required: boolean;

  @Prop(String) readonly placeholder: string;

  @Prop(Object) readonly eventsConfig: any;

  @Prop(String) readonly conditionalClass: string;

  @Prop(Object) readonly formModel: AnyEntity;

  @Prop({
    type: Boolean,
    default: false,
  })
  readonly translatable: boolean;
  @Prop({
    type: Boolean,
    default: false,
  })
  readonly autofocus: boolean;

  public extraData = {};

  get baseLang(): string {
    return this.$store.getters['centerSettings/defaultLanguage'];
  }

  get userLang(): string {
    return this.$store.getters['auth/userLang'];
  }

  get totalAvailableLanguages() {
    return this.$store.getters['centerSettings/totalAvailableLanguages'];
  }

  get isDisabled(): boolean {
    if (
      !this.disabled &&
      this.translatable &&
      this.baseLang !== this.userLang &&
      this.formModel['id']
    ) {
      return true;
    } else if (this.disabled !== null || this.disabled !== undefined) {
      return this.disabled;
    } else if (this.fieldAttributes) {
      return get(this.fieldAttributes, 'disabled', false);
    }

    return false;
  }

  get fieldId(): string {
    return this.id || this.name;
  }

  get fieldWrapperAttributes(): object {
    return {
      id: this.fieldId,
      name: this.name,
      state: this.state,
      showLabel: this.showLabel,
      label: this.label,
      labelClass: this.labelClass,
      labelAttributes: this.labelAttributes,
      veeValidation: this.veeValidation,
      showError: this.showError,
      errorClass: this.errorClass,
      errorAttributes: this.errorAttributes,
      error: this.error,
      rules: this.rules,
      showHelp: this.showHelp, // Deprecated
      helpMode: this.helpMode,
      helpClass: this.helpClass,
      helpAttributes: this.helpAttributes,
      help: this.help,
      showFeedback: this.showFeedback,
      feedbackClass: this.feedbackClass,
      feedbackAttributes: this.feedbackAttributes,
      feedback: this.feedback,
      wrapperAttributes: this.wrapperAttributes,
      disabled: this.disabled,
      required: this.required,
    };
  }

  mounted() {
    if (this.eventsConfig && this.eventsConfig.subscribe) {
      Object.entries(this.eventsConfig.subscribe).forEach(event => {
        this.$root.$on(event[0], val => {
          this.handleEvent(event[0], event[1], val);
        });
      });
    }
  }
  destroyed() {
    if (this.eventsConfig && this.eventsConfig.subscribe) {
      Object.entries(this.eventsConfig.subscribe).forEach(event => {
        this.$root.$off(event[0]);
      });
    }
  }

  handleEvent(eventName: string, event: any, val: any) {
    this.extendHandleEvent(eventName, event, val);
    console.log(eventName);
  }
  extendHandleEvent(eventName: string, event: any, val: any) {
    console.log('extend ' + eventName);
  }
}
